<template>
  <div class="graphContainer" style="height: 320px; margin-top: 50px;">
    <!-- <p style="font-size: 32px;">{{ doughnutData }}</p> -->
    <div class="graphContainerBack">
      <pie-chart :width="640" :height="380" style="position: absolute;" :chartData="labelsData" :options="labelsOptions"/>
    </div>
    <div class="graphContainerBack">
      <pie-chart :width="640" :height="340" style="position: absolute;" :chartData="backdropData" :options="backdropOptions"/>
    </div>
    <div class="graphContainerFront">
      <pie-chart :width="240" :height="240" :chartData="doughnutData" :options="doughnutOptions"/>
    </div>
  </div>
</template>
<script>
import PieChart from "@/components/PieChart"

export default {
  name: "marks-diagram",
  props: {
    doughnutData: {
      type: Object
    },
  },
  data() {
    return {
      doughnutOptions: {
        events: [],
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: (items, data) => {
              return data.labels[items[0].index]
            },
            label: (item, data) => {
              return data.datasets[0].data[item.index] + '%'
            }
          }
        },
        plugins: {
          datalabels: {
            formatter: function(value, context) {
              return Number(context.chart.data.datasets[0].data[context.dataIndex]).toLocaleString('en', { maximumFractionDigits: 0 }) + '%'
             },
            color: function(context) {
              return context.dataset.fontColor[context.dataIndex]
            },
            offset: (context) => {
              return context.dataset.offset[context.dataIndex]
            },
            align: 'end',
            // anchor: 'end',
            clip: true,
            display: true,
            borderRadius: 3,
            font: {
              size: 18,
            },
          },
        },
      },
      backdropData: {
        labels: ['People', 'Process', 'Technology'],
        datasets: [{
          data: [14, 26, 60],
          backgroundColor: [
            '#1B2965',
            '#D79C1D',
            '#A62128'
          ],
          fontColor: [
            '#ffffff',
            '#ffffff',
            '#ffffff'
          ],
          alignList: [
            'end',
            'end',
            'end'
          ],
          offsetList: [
            40,
            40,
            32
          ]
        }]
      },
      backdropOptions: {
        events: [],
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            formatter: function(value, context) {
              return Number(context.chart.data.datasets[0].data[context.dataIndex]).toLocaleString('en', { maximumFractionDigits: 0 }) + '%'
            },
            color: function(context) {
              return context.dataset.fontColor[context.dataIndex]
            },
            align: function(context) {
              return context.dataset.alignList[context.dataIndex]
            },
            offset: function(context) {
              return context.dataset.offsetList[context.dataIndex]
            },
            // anchor: 'end',
            clip: false,
            display: true,
            borderRadius: 3,
            font: {
              size: 18,
            },
          },
        },
      },
      labelsData: {
        labels: ['People', 'Process', 'Technology'],
        datasets: [{
          data: [14, 26, 60],
          backgroundColor: [
            'rgba(0, 0, 0, 0)',
            'rgba(0, 0, 0, 0)',
            'rgba(0, 0, 0, 0)'
          ],
          fontColor: [
            '#1B2965',
            '#D79C1D',
            '#A62128'
          ],
          alignList: [
            'end',
            'right',
            'left'
          ],
          offsetList: [
            80,
            100,
            90
          ]
        }]
      },
      labelsOptions: {
        events: [],
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            formatter: function(value, context) {
              return context.chart.data.labels[context.dataIndex]
            },
            color: function(context) {
              return context.dataset.fontColor[context.dataIndex]
            },
            align: function(context) {
              return context.dataset.alignList[context.dataIndex]
            },
            offset: function(context) {
              return context.dataset.offsetList[context.dataIndex]
            },
            // anchor: 'end',
            clip: false,
            display: true,
            borderRadius: 3,
            font: {
              size: 24,
              weight: 500
            },
          },
        },
      },
    }
  },
  computed: {
  },
  components: {
    PieChart
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/sfera/components/MarksDiagram/index.vue